<template>
  <div class="padding-bottom-60">
    <ul class="m-menu__nav m-menu__nav--dropdown-submenu-arrow padding-0">
      <router-link v-for="(page, i) in navigationPages" :key="i" tag="li" :to="page.to" class="m-menu__item"
                   aria-haspopup="true" exact
                   :active-class="`m-menu__item--active m-menu__item--active-ls`">
        <a class="m-menu__link">
          <i class="m-menu__link-icon" :class="page.icon"></i>
          <span class="m-menu__link-title">
          <span class="m-menu__link-wrap">
            <span class="m-menu__link-text" :class="{'word-break-all': shouldBreakTitle(page.title)}" v-encode="page.title"></span>
            <span v-if="page.to.name === 'MessagesPage' && unreadMessages" class="m-badge pull-right m-badge--ls">{{unreadMessages}}</span>
          </span>
        </span>
        </a>
      </router-link>
    </ul>
  </div>
</template>

<script>
  import {mapState} from 'vuex'
  import Encode from '@/directives/encode'

  export default {
    name: "Navigation",
    props: {
      isNav: Boolean
    },
    directives: {
      Encode
    },
    methods: {
      shouldBreakTitle(title) {
        return title.split(' ')[0].length > 30
      }
    },
    computed: {
      ...mapState({
        unreadMessages: state => state.auth.user.unread_messages,
        navigationPages: state => state.navigation.pages,
      }),
    }
  }
</script>

<style>
  .m-aside-menu.m-aside-menu--skin-light .m-menu__nav > .m-menu__item.m-menu__item--active-ls > .m-menu__link .m-menu__link-text {
    color: var(--accent-color) !important;
  }

  .m-aside-menu.m-aside-menu--skin-light .m-menu__nav > .m-menu__item.m-menu__item--active-ls > .m-menu__link .m-menu__link-icon {
    color: var(--accent-color) !important;
  }

  .padding-0 {
    padding: 0 !important;
  }

  .padding-bottom-60 {
    padding-bottom: 60px;
  }

  .word-break-all {
    word-break: break-all;
  }

  .m-badge {
    font-weight: 500;
  }

</style>
